import {SxType} from '@baseTypes/sx/sxTypes'

export default {
	root: {
		width: '100%',
		height: '100%',
		bgcolor: 'background.paper',
		position: 'relative',
		overflow: 'hidden',
	},
	stage: {
		width: '100%',
		height: '100%',
		position: 'relative',
		bgcolor: '#000',
	},
	video: {
		width: '100%',
		height: '100%',
		display: 'block',
		objectFit: 'contain',
		bgcolor: '#000',
	},
	changeBtn: {
		position: 'absolute',
		top: 8,
		left: 8,
		zIndex: 10,
		px: 1.25,
		py: 0.25,
		minWidth: 0,
		borderRadius: '999px',
		textTransform: 'none',
		fontSize: '12px',
		fontWeight: 600,
		color: '#fff',
		bgcolor: 'rgba(0, 0, 0, 0.5)',
		backdropFilter: 'blur(6px)',
		boxShadow: 'none',
		'&:hover': {
			bgcolor: 'rgba(0, 0, 0, 0.75)',
			boxShadow: 'none',
		},
		'& .MuiButton-startIcon': {
			mr: 0.5,
		},
	},
	list: {
		p: 2,
		height: '100%',
		overflowY: 'auto',
	},
	listTitle: {
		fontSize: '14px',
		fontWeight: 700,
		mb: 1.5,
	},
	host: {
		display: 'block',
		mb: 0.5,
		color: 'text.secondary',
	},
	cameraRow: {
		display: 'flex',
		alignItems: 'center',
		gap: 1,
		mb: 0.75,
	},
	cameraBtn: {
		flex: 1,
		justifyContent: 'flex-start',
		borderRadius: '10px',
		textTransform: 'none',
		fontWeight: 600,
		borderColor: 'var(--account-accent-tint, rgba(12, 109, 223, 0.35))',
		bgcolor: 'var(--account-accent-soft, transparent)',
		'&:hover': {
			borderColor: 'var(--account-accent, #0C6DDF)',
			bgcolor: 'var(--account-accent-soft, transparent)',
		},
	},
	quality: {
		ml: 'auto',
		height: 20,
		fontSize: '10px',
		fontWeight: 700,
	},
	link: {
		color: 'var(--account-accent, #0C6DDF)',
	},
} as const satisfies Record<string, SxType>
